export default "__VITE_ASSET__261739ed__"